import { Component } from '@angular/core';

@Component({
  selector: 'app-demo-prescription',
  templateUrl: './demo-prescription.component.html',
  styleUrls: ['./demo-prescription.component.scss']
})
export class DemoPrescriptionComponent {

  showHideDemoPrescription: boolean = false;

  onShowHideDemoPrescription() {
    this.showHideDemoPrescription = !this.showHideDemoPrescription;
  }

}
